export default __webpack_public_path__ + "static/media/fruces-shots.68fb8504.jpg";